module.exports = __webpack_public_path__ + "img/Czech.a4cc7e5e.png";